import { render, staticRenderFns } from "./InfoRectIcon.vue?vue&type=template&id=5f174d6c&scoped=true"
import script from "./InfoRectIcon.vue?vue&type=script&lang=js"
export * from "./InfoRectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f174d6c",
  null
  
)

export default component.exports